import { useQuery } from '@tanstack/react-query';
import { ImportDropzone } from '../components/ImportDropzone.js';
import { Button } from '../components/ui/Button.js';
import { useSeed } from '../hooks/useData.js';
import { api } from '../lib/api.js';

export function Employees() {
  const seed = useSeed();
  const list = useQuery({ queryKey: ['employees'], queryFn: () => api.employees(200) });

  return (
    <div className="mx-auto max-w-3xl space-y-6 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Employees / assets</h1>
        <Button variant="primary" disabled={seed.isPending} onClick={() => seed.mutate(undefined)}>
          {seed.isPending ? 'Loading…' : 'Load 200 sample employees'}
        </Button>
      </div>

      <ImportDropzone />

      <p className="text-xs text-[var(--color-muted)]">
        Required columns: <code className="mono">name</code> or{' '}
        <code className="mono">external_id</code>, plus <code className="mono">address</code> or (
        <code className="mono">lat</code> + <code className="mono">lng</code>). Optional:{' '}
        <code className="mono">email</code>, <code className="mono">role</code>,{' '}
        <code className="mono">location_label</code>.
      </p>

      <div className="rounded-lg border border-[var(--color-border)]">
        <div className="border-b border-[var(--color-border)] px-3 py-2 text-xs text-[var(--color-muted)]">
          {list.data?.total ?? 0} active
        </div>
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-[var(--color-muted)]">
            <tr>
              <th className="px-3 py-2">ID</th>
              <th className="px-3 py-2">Name</th>
              <th className="px-3 py-2">Role</th>
              <th className="px-3 py-2">Location</th>
            </tr>
          </thead>
          <tbody>
            {(list.data?.employees ?? []).slice(0, 50).map((e) => (
              <tr key={String(e.id)} className="border-t border-[var(--color-border)]">
                <td className="mono px-3 py-1.5 text-xs">{String(e.external_id ?? e.id)}</td>
                <td className="px-3 py-1.5">{String(e.name ?? '—')}</td>
                <td className="px-3 py-1.5">{String(e.role ?? '—')}</td>
                <td className="px-3 py-1.5">{String(e.location_label ?? '—')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
